import { useState } from 'react'

import { useIsomorphicLayoutEffect } from '@unlikelystudio/react-hooks'

const useWindowActive = (initialState = true) => {
  const [active, setActive] = useState(initialState)

  const onVisibilityChange = () => setActive(!document?.hidden)

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      window.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  return active
}

export default useWindowActive
